import { ReactNode } from "react";

type Props = {
  icon?: ReactNode;
  heading?: ReactNode;
  message?: ReactNode;
  action?: ReactNode;
};

export const EmptyState = ({ icon, heading, message, action }: Props) => {
  return (
    <div className="flex flex-col items-center text-center">
      {icon}
      <h3 className="mt-2 text-md font-medium text-gray-900">{heading}</h3>
      <p className="mt-1 text-sm font-medium text-secondary">{message}</p>
      <div className="mt-6">{action}</div>
    </div>
  );
};

export default {};
